import { addDays, startOfDay, subDays } from "date-fns";

export const getCicloAtual = () => {
  const hoje = new Date();
  const diaDaSemana = hoje.getDay();

  let sextaInicioCiclo;
  if (diaDaSemana === 5) {
      sextaInicioCiclo = startOfDay(hoje);
  } else {
      const diasDesdeSexta = (diaDaSemana + 1) % 7 + 1;
      sextaInicioCiclo = startOfDay(subDays(hoje, diasDesdeSexta));
  }

  let quintaFechaCiclo = addDays(sextaInicioCiclo, 6);

  return {
    sextaInicioCiclo,
    quintaFechaCiclo
  };
};
